import { ReactComponent as LocationIcon } from "../../../Assets/Icons/newLocation.svg";
import image from "../../../Assets/Icons/Image.svg";
import { getS3PublicUrl } from "../../../utils/s3";

export default function RedeemedOffers({ offerDetails }) {
  console.log("offerDetails", offerDetails);
  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="max-h-[600px] overflow-y-auto w-full md:w-auto flex flex-col gap-4 font-poppins bg-white p-4 sm:p-6 rounded-lg"
    >
      <div className="w-full flex binding flex-col sm:flex-row justify-start items-start sm:items-center gap-4">
        <img
          src={
            offerDetails?.merchant?.logo
              ? getS3PublicUrl(offerDetails?.merchant?.logo)
              : image
          }
          className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] border border-[#0000001A] rounded-full object-cover"
        />
        <div className="flex flex-col justify-start items-start">
          <p className="text-[20px] sm:text-[24px] font-[600] text-[#000000]">
            {offerDetails?.merchant?.businessName}
          </p>
          <div className="flex items-center gap-2">
            <LocationIcon />
            <p className="text-[12px] sm:text-[14px] font-[400] text-[#767676] break-all">
              {offerDetails?.merchant?.address}
            </p>
          </div>
        </div>
      </div>
      <h2 className="text-[18px] sm:text-[20px] font-[600] text-[#000000] text-start">
        Offers Redeemed
      </h2>
      <div className="w-full flex flex-col gap-4">
        {offerDetails?.offers?.length > 0 ? (
          offerDetails?.offers?.map((offer, index) => (
            <div key={index} className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 gap-3 border-b border-gray-100 sm:border-none">
              <div className="flex items-center gap-3 w-full sm:w-auto">
                <img
                  src={
                    offer?.thumbnailImage
                      ? getS3PublicUrl(offer?.thumbnailImage)
                      : image
                  }
                  className="w-[60px] h-[45px] sm:w-[80px] sm:h-[60px] rounded-[4px] object-cover flex-shrink-0"
                />
                <div className="flex flex-col justify-start items-start min-w-0">
                  <p className="text-[14px] sm:text-[16px] font-[600] text-[#000000] break-words line-clamp-2">
                    {offer?.title}
                  </p>
                </div>
              </div>
              <div className="bg-[#E6F8FF] p-2 border-2 border-[#00ADEF] rounded-[4px] self-start sm:self-center flex-shrink-0">
                <h4 className="text-[#00ADEF] font-[500] text-[10px] sm:text-[12px] font-poppins whitespace-nowrap">
                  {offer?.offerType === "INSTORE_SWOODLE_OFFER"
                    ? "INSTORE SWOODLE OFFER"
                    : "ONLINE OFFER"}
                </h4>
              </div>
            </div>
          ))
        ) : (
          <p className="text-[16px] font-[400] text-[#767676]">
            No redeemed offers available.
          </p>
        )}
      </div>
    </div>
  );
}
